import { Controller } from "@hotwired/stimulus"
import { swipeableMixin } from "./mixins/swipeable"

/**
 * Chat Swipe Controller - iOS Mail-style swipe-to-hide
 *
 * Uses shared swipeable mixin for touch handling.
 * Adds chat-specific hide action via Turbo Stream.
 * Hidden chats are automatically restored when the other user sends a message.
 *
 * Usage:
 * <div data-controller="chat-swipe"
 *      data-chat-swipe-chat-id-value="123"
 *      data-chat-swipe-hide-url-value="/chats/123/hide"
 *      data-chat-swipe-threshold-value="50"
 *      data-chat-swipe-delete-width-value="80">
 *   <a data-chat-swipe-target="card">...</a>
 *   <div data-chat-swipe-target="deleteAction">
 *     <button data-action="click->chat-swipe#hide">隱藏</button>
 *   </div>
 * </div>
 */
export default class extends Controller {
  static targets = ["card", "deleteAction"]
  static values = {
    chatId: Number,
    hideUrl: String,  // Rails route helper로 전달 (e.g., hide_chat_path)
    threshold: { type: Number, default: 50 },
    deleteWidth: { type: Number, default: 80 }
  }

  connect() {
    swipeableMixin.setup(this)
  }

  disconnect() {
    swipeableMixin.teardown(this)
  }

  /**
   * Hide chat via Turbo Stream
   * URL은 ERB에서 Rails route helper로 주입
   */
  hide(event) {
    event.preventDefault()
    event.stopPropagation()

    const hideUrl = this.hideUrlValue
    if (!hideUrl) {
      console.error('chat-swipe: hideUrl value is required')
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    // Add slide-out animation before removing
    this.element.classList.add('animate-slide-out-right')

    fetch(hideUrl, {
      method: 'PATCH',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': csrfToken
      }
    }).then(response => {
      if (response.ok) {
        return response.text()
      }
      throw new Error('Hide failed')
    }).then(html => {
      Turbo.renderStreamMessage(html)
    }).catch(error => {
      console.error('Failed to hide chat:', error)
      this.element.classList.remove('animate-slide-out-right')
      swipeableMixin.resetPosition(this)
    })
  }
}
